export default {"src":"/_next/static/media/growth-lg.colour.d37d4c2b.svg","height":233,"width":364,"blurWidth":0,"blurHeight":0};